import React from 'react';
import PropTypes from 'prop-types';
import { Typography, withStyles } from '@material-ui/core';
import HittaLogo from '../HittaLogo/HittaLogo';

const styles = theme => ({
    root: {
        margin: theme.spacing(2),
        '@media print': {
            textAlign: 'right',
        },
    },
    logo: {
        marginRight: theme.spacing(1),
        verticalAlign: 'bottom',
    },
});

const PrintHeader = ({
    classes,
    size,
    title,
}) => (
    <div className={classes.root}>
        <HittaLogo size={size} classes={classes.logo} rightMargin={13} />
        <Typography display="inline" gutterBottom variant="h5" component="h5">
            {title}
        </Typography>
    </div>
);

PrintHeader.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    title: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
};


export default withStyles(styles)(PrintHeader);
